import React from "react";

import { IikoTerminalDto } from "services/menu/restModels";

import {
    Button,
    DataTable,
    DataTableColumn,
    DeleteIcon,
    EmptyState,
    IconButton,
    SectionCard,
} from "shared/ui";

import { useIikoIntegrationContext } from "features/IikoIntegration/context";

import {
    AddTerminal,
    CompactAction,
    Identifier,
    TerminalDot,
    TerminalSelect,
    WideAction,
} from "./styles";

/*
* Третий шаг мастера. Каждое добавление и удаление — отдельный запрос: список правится по
* одному терминалу, копить изменения до общей кнопки «Сохранить» тут нечего.
* */
export const TerminalsStep = () => {
    const state = useIikoIntegrationContext();

    const columns: DataTableColumn<IikoTerminalDto>[] = [
        {
            key: "indicator",
            role: "indicator",
            render: () => <TerminalDot />,
        },
        {
            key: "name",
            title: "Терминал",
            role: "primary",
            render: (terminal) => state.terminalName(terminal.terminalGroupId),
        },
        {
            key: "id",
            title: "Идентификатор",
            role: "secondary",
            width: 240,
            render: (terminal) => <Identifier>{terminal.terminalGroupId}</Identifier>,
        },
        {
            key: "actions",
            role: "action",
            width: 120,
            render: (terminal) => (
                <>
                    <WideAction>
                        <Button
                            variant="outlined"
                            color="danger"
                            size="compact"
                            disabled={state.saving.terminal}
                            onClick={() => state.requestRemoveTerminal(terminal)}
                        >
                            Удалить
                        </Button>
                    </WideAction>

                    <CompactAction>
                        <IconButton
                            label="Удалить терминал"
                            tone="danger"
                            disabled={state.saving.terminal}
                            onClick={() => state.requestRemoveTerminal(terminal)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </CompactAction>
                </>
            ),
        },
    ];

    return (
        <SectionCard
            title="Терминалы"
            description="Кассы iiko, в которые уходят заказы этого меню. Изменения сохраняются сразу."
            headerRight={
                <AddTerminal>
                    <TerminalSelect
                        value={state.selectedTerminalId}
                        options={state.terminalOptions}
                        disabled={state.saving.terminal}
                        onChange={state.setSelectedTerminalId}
                        title="Терминал iiko"
                    />
                    <Button
                        variant="contained"
                        disabled={!state.selectedTerminalId || state.saving.terminal}
                        onClick={state.submitTerminal}
                    >
                        Добавить
                    </Button>
                </AddTerminal>
            }
        >
            {state.terminals.length === 0 ? (
                <EmptyState
                    title="Терминалы не добавлены"
                    description="Пока ни одна касса не выбрана, заказы из этого меню в iiko не попадут."
                />
            ) : (
                <DataTable
                    columns={columns}
                    rows={state.terminals}
                    rowKey={(terminal) => terminal.terminalGroupId}
                />
            )}
        </SectionCard>
    );
};
